module.exports = __webpack_public_path__ + "static/media/Travonga-O-640-60.1db06fbd.jpg";